const isNonEmptyValue = (value, clearNulls)=>'' !== value && void 0 !== value && (!clearNulls || null !== value);
function filterEmptyProps(clearNulls) {
    return function(obj) {
        if ('object' != typeof obj || null === obj) return obj;
        return Object.keys(obj).reduce((newObj, prop)=>{
            const value = obj[prop];
            if (isNonEmptyValue(value, clearNulls)) newObj[prop] = value;
            return newObj;
        }, {});
    };
}
function withoutEmptyProps(data, clearNulls = false) {
    if (Array.isArray(data)) return data.map(filterEmptyProps(clearNulls));
    return filterEmptyProps(clearNulls)(data);
}
export { withoutEmptyProps };
